// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__1X_hf","text":"styles_text__1oGmj","about":"styles_about__29bY8","padding":"styles_padding__2JydB"};